import { ViabilityForm } from '../../components/ViabilityForm'

import { getDaysToLoseOneProbit } from '../../util'
import { createFileRoute } from '@tanstack/react-router'

const DaysToLoseOneProbitCalculator = () => {
  return (
    <ViabilityForm
      calculation={getDaysToLoseOneProbit}
      title="Predict days to lose one probit"
      renderResultComponent={(result) => (
        <>
          <h3 className="text-lg font-bold">{result.toFixed(1)} days</h3>
          {result > 365 && (
            <h3 className="text-lg font-bold">
              {(result / 365).toFixed(1)} years
            </h3>
          )}
        </>
      )}
      info="This tool is based on the viability equations of Ellis and Roberts (1980). It predicts the length of time it takes for seed lot viability to fall by one probit, for example, from 99.87 to 97.73%, from 99.73 to 84.13%, or from 84.13 to 50%, depending on the species and storage moisture content and temperature"
    />
  )
}

export const Route = createFileRoute('/viability/lose-one-probit-days')({
  component: DaysToLoseOneProbitCalculator,
})
